import ReportPage from "../../components/ReportPage";
import { downloadDistributionSummary } from "../../API";

const schema = {
  title: "Stock Level Summary",
  params: [
    { name: "banners", label: "Banners", type: "multiselect", route: "banners", fields: ["name"], payloadKey: "bannerIds", required: true },
    {
      name: "products",
      label: "Products",
      type: "multiselect",
      route: "products",
      cascadesFrom: "manufacturer",
      fields: ["description", "formatQut", "format"],
      payloadKey: "productIds",
      required: true,
      dependsOnValues: ["banners"],
      buildQueryFn: (manufacturer, commonParams, localValues) => {
        const p = new URLSearchParams();
        p.set("manufacturerId", manufacturer.id);
        const status = localValues?.productStatus?.id ?? commonParams.itemStatus ?? "ACTIVE";
        if (status !== "ALL") p.set("status", status);
        (commonParams.provinces ?? []).forEach((pr) => p.append("provinceIds", pr.id));
        ((localValues ?? {}).banners ?? []).forEach((b) => p.append("bannerIds", b.id));
        return `/for-report-selector?${p.toString()}`;
      },
    },
  ],
  downloadFn: downloadDistributionSummary,
};

export default function DistributionSummaryReport() {
  return <ReportPage schema={schema} />;
}
